import { Component, Input, OnInit } from '@angular/core';

import { isClienteCadastroCliente } from '../cadastro';
import { isClienteSituacaoAtivo } from '../situacao';

interface Config {
    isCadastroCliente: boolean;
    isSituacaoAtivo: boolean;
}

@Component({
    selector: 'sgt-cliente-form-text',
    templateUrl: 'cliente-form-text.component.html',
    styleUrls: ['./cliente-form-text.component.less']
})
export class ClienteFormTextComponent implements OnInit {
    config: Config;

    // Situação
    @Input() isShowCadastroSituacao = false;
    @Input() cadastro: number;
    @Input() situacao: number;


    @Input() nomeFantasia: string;
    @Input() cnpjCpf: string;
    @Input() nomeCidade: string;
    @Input() uf: string;
    @Input() rotaEntregaErpSCR: string;

    ngOnInit() {
        this.createConfig();
    }

    private createConfig() {
        this.config = {
            isCadastroCliente: isClienteCadastroCliente(this.cadastro),
            isSituacaoAtivo: isClienteSituacaoAtivo(this.situacao)
        };
    }
}

